import logo from './logo.svg';
import './App.css';
import RarityBackgroundGenerator from './rarityGenerator'


function App() {
  return (
    <div className="App">
     <RarityBackgroundGenerator>

     </RarityBackgroundGenerator>
    </div>
  );
}

export default App;
